import { useState, useEffect, useRef } from 'react'
import { useForm, Controller } from 'react-hook-form'
import UploadFileControl from '../formcomponents/uploadFileControl'
import IformBreadcrumb from '../formcomponents/iformBreadcrumb'
import { TextField, Button, Typography, InlineAlert } from '@nwh-consumer-digital/nw-component-lib'
import { Grid, Box, Paper } from '@mui/material'
import styled from '@emotion/styled'
import { useProgress } from '../context/ProgressContext'

const TodayTS = Date.now()

const Item = styled(Paper)(() => ({
  textAlign: 'left',
  maxWidth: '400px',
  marginBottom: '18px', // There is an extra 6 pixels this makes 24px
}))

const isValidEmail = (email) =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  )

const getDocumentationLabel = (relationshiptoPatient) => {
  const baseText = `*Si usted es el ${relationshiptoPatient} del paciente, adjunte a este formulario copias de cualquier documentación legal que demuestre que usted `
  switch (relationshiptoPatient) {
    case 'Tutor legal':
      return `${baseText} es el tutor, si dicha documentación no está en el expediente médico del paciente.`
    case 'Poder Duradero (DPOA)':
      return `${baseText} tiene el poder duradero.`
    default:
      break
  }
}

const minorPageTwo = (props) => {
  //UseProgress Context Hook
  const { updateProgress } = useProgress()

  useEffect(() => {
    // Set Value For Progress
    updateProgress(60)

    if (relationshiptoPatient !== 'Padre/madre') {
      setNeedsLegalDocumentation(true)
    } else {
      setNeedsLegalDocumentation(false)
      setIsFileUploadSt(true)
    }

    if (SubmissionState.sectionTwoForm) {
      setValue('firstNameGuardian', SubmissionState.sectionTwoForm?.firstNameGuardian)
      setValue('lastNameGuardian', SubmissionState.sectionTwoForm?.lastNameGuardian)
      setValue('mInitialGuardian', SubmissionState.sectionTwoForm?.mInitialGuardian)
      setValue('DOBGuardian', SubmissionState.sectionTwoForm?.DOBGuardian)
      setValue('streetNumberGuardian', SubmissionState.sectionTwoForm?.streetNumberGuardian)
      setValue('CityGuardian', SubmissionState.sectionTwoForm?.CityGuardian)
      setValue('StateGuardian', SubmissionState.sectionTwoForm?.StateGuardian)
      setValue('ZipGuardian', SubmissionState.sectionTwoForm?.ZipGuardian)
      setValue('phoneNumberGuardian', SubmissionState.sectionTwoForm?.phoneNumberGuardian)
      setValue('emailguardian', SubmissionState.sectionTwoForm?.emailguardian)
    }
  }, [])

  const { SubmissionState, onFormStateChange } = props
  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({ mode: 'onBlur' })

  // Count the number of errors on the page and, if any are found, scroll to the reference above the inline alert box after tallying them.
  const errorCount = Object.keys(errors).length
  const targetRef = useRef(null)
  const scrollToTarget = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }
  useEffect(() => {
    if (errorCount > 0) {
      scrollToTarget()
    }
  }, [errors])

  const [isfileUploadSt, setIsFileUploadSt] = useState(false)
  const [NeedsLegalDocumentation, setNeedsLegalDocumentation] = useState(false)
  const relationshiptoPatient = SubmissionState?.sectionOneForm.relationshiptoPatient
  const patientName =
    SubmissionState.sectionOneForm.lastName + '_' + SubmissionState.sectionOneForm.firstName + '_' + TodayTS

  const uploadCompleted = function (state) {
    setIsFileUploadSt(state)
  }

  const handleEmailValidation = (email) => {
    const isValid = isValidEmail(email)
    const validityChanged = (errors.email && isValid) || (!errors.email && !isValid)
    if (validityChanged) {
    }
    return isValid
  }

  const handleRegistration = (data) => {
    SubmissionState.goBackPageTwo = false
    SubmissionState.goPageThree = true
    SubmissionState.SectionTwoFormTimestamp = TodayTS
    SubmissionState.sectionTwoForm = data
    onFormStateChange()
  }

  const previousPageClick = () => {
    SubmissionState.goBackPageTwo = false
    SubmissionState.goBackPageOne = true
    SubmissionState.sectionTwoForm = getValues()
    onFormStateChange()
  }

  return (
    <Box>
      <Grid container direction="column" justifyContent="space-between" alignItems="left">
        <Grid
          item
          xs={12}
          sx={{
            marginTop: {
              xs: '1.25rem',
              sm: '1.25rem',
              md: '1.25rem',
              lg: '2rem',
              xl: '2rem',
            },
            marginBottom: {
              xs: '2rem',
              sm: '2rem',
              md: '2rem',
              lg: '2rem',
              xl: '2rem',
            },
          }}>
          <IformBreadcrumb onClick={previousPageClick}>&lt; Menores información</IformBreadcrumb>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h1" style={{ marginBottom: 24 }}>
            Requestor's información
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            maxWidth: window.innerWidth <= 768 ? '400px' : 'none',
            marginBottom: 24,
            textAlign: 'justify',
            lineHeight: 1.6,
            wordSpacing: '0.05em',
          }}>
          <Typography type="body" size="large" weight="light">
            {' '}
            Enter the details of the requestor's information to proceed with the proxy access request for the minor
            patient.
          </Typography>
        </Grid>
        <form id="completeFMHminorForm" onSubmit={handleSubmit(handleRegistration)}>
          <Grid item xs={12} className="requiredSpacing">
            <Item elevation={0}>
              <label ref={targetRef} className="required">
                <span className="red">*</span> Requerido
              </label>
            </Item>
          </Grid>
          {errorCount > 0 && (
            <Grid item xs={12}>
              <Item elevation={0}>
                <InlineAlert severity="error" fullWidth text={`There are ${errorCount} errors on this page.`} />
              </Item>
            </Grid>
          )}
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="firstNameGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="firstNameGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.firstNameGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        Apoderado Primer Nombre <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={errors?.firstNameGuardian}
                    helperText={
                      errors?.firstNameGuardian
                        ? errors?.firstNameGuardian?.type === 'required'
                          ? 'First name is required.'
                          : errors?.firstNameGuardian?.type === 'pattern'
                          ? 'First name contains invalid characters.'
                          : 'First name is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="lastNameGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="lastNameGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.lastNameGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        Apoderado Apellido <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.lastNameGuardian)}
                    helperText={
                      errors?.lastNameGuardian
                        ? errors?.lastNameGuardian?.type === 'required'
                          ? 'Last name is required.'
                          : errors?.lastNameGuardian?.type === 'pattern'
                          ? 'Last name contains invalid characters.'
                          : 'Last name is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="mInitial"
                control={control}
                rules={{ pattern: { value: /^[A-Za-z]+$/, message: 'Please use alphabetic characters only' } }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    id="mInitialGuardian"
                    onChange={onChange}
                    defaultValue={SubmissionState.sectionTwoForm?.mInitialGuardian}
                    label="Apoderado Inicial Del Segundo Nombre"
                    fullWidth
                    error={Boolean(errors?.mInitialGuardian)}
                    helperText={errors?.mInitialGuardian?.message || ''}
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="DOBGuardian"
                control={control}
                rules={{
                  pattern:
                    /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/(19\d{2}|20[0-2]\d|20[2-9][0-9]|20[3-9][0-9]|21\d{2})$/,
                  required: true,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="DOBGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.DOBGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        Apoderado Fecha de nacimiento (MM/DD/YYYY) <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.DOBGuardian)}
                    helperText={
                      errors?.DOBGuardian
                        ? errors?.DOBGuardian?.type === 'required'
                          ? 'Date of Birth is required.'
                          : errors?.DOBGuardian?.type === 'pattern'
                          ? 'Please use numeric characters only, and correct Month/Date/Year values.'
                          : 'Date of Birth is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="streetNumberGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Za-z0-9 -]+$/,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="streetNumberGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.streetNumberGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        Calle apoderado <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.streetNumberGuardian)}
                    helperText={
                      errors?.streetNumberGuardian
                        ? errors?.streetNumberGuardian?.type === 'required'
                          ? 'Address is required.'
                          : errors?.streetNumberGuardian?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : 'Address is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="CityGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="CityGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.CityGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        Ciudad apoderado <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.CityGuardian)}
                    helperText={
                      errors?.CityGuardian
                        ? errors?.CityGuardian?.type === 'required'
                          ? 'City is required.'
                          : errors?.CityGuardian?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : 'City is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="StateGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="StateGuardian"
                    defaultValue={SubmissionState.sectionTwoForm?.StateGuardian}
                    onChange={onChange}
                    label={
                      <span>
                        Estado apoderado <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.StateGuardian)}
                    helperText={
                      errors?.StateGuardian
                        ? errors?.StateGuardian?.type === 'required'
                          ? 'State is required.'
                          : errors?.StateGuardian?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : 'State is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="ZipGuardian"
                control={control}
                rules={{
                  pattern: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
                  required: true,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="ZipGuardian"
                    onChange={onChange}
                    defaultValue={SubmissionState.sectionTwoForm?.ZipGuardian}
                    label={
                      <span>
                        Código postal apoderado <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={errors?.ZipGuardian}
                    helperText={
                      errors?.ZipGuardian
                        ? errors?.ZipGuardian?.type === 'required'
                          ? 'Zipcode is required.'
                          : errors?.ZipGuardian?.type === 'pattern'
                          ? 'Please use 5 digits of numeric characters only'
                          : 'Zipcode is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="phoneNumberGuardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^(\+1)?[ -]?\(?([0-9]{3})\)?[ -]?([0-9]{3})[ -]?([0-9]{4})$/,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="phoneNumberGuardian"
                    onChange={onChange}
                    defaultValue={SubmissionState.sectionTwoForm?.phoneNumberGuardian}
                    label={
                      <span>
                        N.º de teléfono apoderado <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.phoneNumberGuardian)}
                    helperText={
                      errors?.phoneNumberGuardian
                        ? errors?.phoneNumberGuardian?.type === 'required'
                          ? 'Phone is required.'
                          : errors?.phoneNumberGuardian?.type === 'pattern'
                          ? 'Please use 9 digits & numeric values only'
                          : 'Phone is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="emailguardian"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z0-9@.!#$%&'*+-/=?^_`{|}~]*$/i,
                  maxLength: 122,
                  validate: handleEmailValidation,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="emailguardian"
                    onChange={onChange}
                    defaultValue={SubmissionState.sectionTwoForm?.emailguardian}
                    label={
                      <span>
                        Apoderado Dirección de email <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.emailguardian)}
                    helperText={
                      errors?.emailguardian
                        ? errors?.emailguardian?.type === 'required'
                          ? 'Email address is required.'
                          : errors?.email?.type === 'pattern'
                          ? 'Enter a valid email address in format: example@example.com'
                          : errors?.email?.type === 'validate'
                          ? 'Enter a valid email address in format: example@example.com'
                          : 'Email address is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
        </form>
        <Grid item xs={12}>
          <Item elevation={0}>
            {NeedsLegalDocumentation && !isfileUploadSt ? (
              <Box className="uploadedFiles">
                <InlineAlert
                  fullWidth
                  severity="info"
                  text={
                    <div>
                      <div style={{ textAlign: 'justify', lineHeight: 1.6 }}>
                        {getDocumentationLabel(relationshiptoPatient)}
                      </div>
                      <div style={{ marginTop: '24px', textAlign: 'left', lineHeight: 1.6 }}>
                        You must upload requested legal documentation to submit form.
                      </div>
                    </div>
                  }
                />
              </Box>
            ) : null}
            {NeedsLegalDocumentation ? (
              <UploadFileControl
                patientName={patientName}
                uploadStateChange={uploadCompleted}
                formid={'MinorProxyForm'}
              />
            ) : null}
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item elevation={0}>
            <form onSubmit={handleSubmit(handleRegistration)}>
              <Button text="Continue" color="primary" type="submit" disabled={!isfileUploadSt} />
            </form>
          </Item>
        </Grid>
      </Grid>
    </Box>
  )
}
export default minorPageTwo
